import { api } from './api';

/**
 * Naviga a /results inferendo automaticamente la categoria dalla query quando
 * l'utente non ne ha scelta una. Usato da tutti i search handler del sito per
 * garantire un comportamento coerente (homepage, header, ricerche correlate).
 *
 * - Timeout 900ms sull'inferenza: se la API è lenta o non risponde, naviga
 *   comunque senza categoria — la ricerca non viene mai bloccata.
 * - Se `forceCategory` è valorizzato (es. utente sta già filtrando su una
 *   categoria specifica), salta l'inferenza e la rispetta.
 * - Aggiunge `category_inferred=1` all'URL per attivare il banner "Categoria
 *   auto-applicata" su ResultsPage.
 */
export function navigateWithInferredCategory(navigate, query, opts = {}) {
  const q = (query || '').trim();
  if (!q) return;
  const { forceCategory = '', extraParams = {} } = opts;
  const params = new URLSearchParams({ q });
  for (const [k, v] of Object.entries(extraParams)) {
    if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
  }
  if (forceCategory && forceCategory !== 'all') {
    params.set('category', forceCategory);
    navigate(`/results?${params.toString()}`);
    return;
  }
  // Navighiamo subito (dentro il tocco): Safari/app Google saltano col "indietro"
  // le voci create dopo un'attesa. La categoria la deduce ResultsPage (infer=1).
  params.set('infer', '1');
  navigate(`/results?${params.toString()}`);
}

export async function inferCategoryWithTimeout(q) {
  try {
    return await Promise.race([
      api.inferCategory(q),
      new Promise(resolve => setTimeout(() => resolve(null), 900)),
    ]);
  } catch { return null; }
}
